module.exports = __webpack_public_path__ + "img/QORO_SLOPE.69a2719b.jpg";